import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { useAssessment } from '../../hooks/useAssessment';
import { Scale, Info, Shield, ArrowLeft } from 'lucide-react';
export function RegulationSelection() {
  const navigate = useNavigate();
  const {
    setRegulation,
    assessment
  } = useAssessment();
  const handleSelectEu = () => {
    setRegulation('EU AI Act');
    navigate('/assessment/risk');
  };
  const handleSelectNist = () => {
    setRegulation('NIST AI RMF');
    navigate('/assessment/nist/govern');
  };
  return <div className="max-w-3xl mx-auto animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-518">
      <div className="mb-8" data-id="element-519">
        <Button variant="ghost" onClick={() => navigate('/assessment/system')} className="mb-4 -ml-2" data-id="element-520">
          <ArrowLeft className="h-4 w-4 mr-2" data-id="element-521" />
          Back to System Definition
        </Button>

        <h1 className="text-3xl font-bold mb-3" data-id="element-522">Select Regulation</h1>
        <p className="text-slate-400 text-lg" data-id="element-523">
          Choose the regulatory framework to assess{' '}
          <span className="text-white font-medium" data-id="element-524">
            {assessment.systemDefinition.name || 'your system'}
          </span>{' '}
          against. This determines the compliance requirements and obligations.
        </p>
      </div>

      <div className="grid gap-6" data-id="element-525">
        {/* EU AI Act Card */}
        <Card className="relative group cursor-pointer border-teal-500/50 hover:border-teal-500 transition-all ring-1 ring-teal-500/20 hover:ring-teal-500/50" onClick={handleSelectEu} data-id="element-526">
          <div className="flex items-start space-x-6" data-id="element-527">
            <div className="flex-shrink-0 h-16 w-16 bg-teal-500/10 rounded-xl flex items-center justify-center border border-teal-500/20" data-id="element-528">
              <Scale className="h-8 w-8 text-teal-500" data-id="element-529" />
            </div>
            <div className="flex-1" data-id="element-530">
              <div className="flex items-center justify-between mb-2" data-id="element-531">
                <h3 className="text-xl font-semibold text-white" data-id="element-532">EU AI Act</h3>
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-teal-500/10 text-teal-400 border border-teal-500/20" data-id="element-533">
                  Active Framework
                </span>
              </div>
              <p className="text-slate-400 mb-4 leading-relaxed" data-id="element-534">
                Comprehensive regulation for Artificial Intelligence in the
                European Union. Focuses on risk classification (Unacceptable,
                High, Limited, Minimal) and specific obligations for high-risk
                systems regarding data governance, transparency, and human
                oversight.
              </p>
              <div className="flex items-center text-sm text-slate-500" data-id="element-535">
                <Info className="h-4 w-4 mr-2" data-id="element-536" />
                <span data-id="element-537">Enforced by European Commission • Last updated 2024</span>
              </div>
            </div>
          </div>
        </Card>

        {/* NIST AI RMF Card */}
        <Card className="relative group cursor-pointer border-slate-700 hover:border-teal-500 transition-all hover:ring-1 hover:ring-teal-500/50" onClick={handleSelectNist} data-id="element-538">
          <div className="flex items-start space-x-6" data-id="element-539">
            <div className="flex-shrink-0 h-16 w-16 bg-slate-800 rounded-xl flex items-center justify-center border border-slate-700 group-hover:bg-teal-500/10 group-hover:border-teal-500/20 transition-colors" data-id="element-540">
              <Shield className="h-8 w-8 text-slate-400 group-hover:text-teal-500 transition-colors" data-id="element-541" />
            </div>
            <div className="flex-1" data-id="element-542">
              <div className="flex items-center justify-between mb-2" data-id="element-543">
                <h3 className="text-xl font-semibold text-white" data-id="element-544">
                  NIST AI RMF
                </h3>
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-teal-500/10 text-teal-400 border border-teal-500/20" data-id="element-545">
                  Active Framework
                </span>
              </div>
              <p className="text-slate-400 mb-4 leading-relaxed" data-id="element-546">
                National Institute of Standards and Technology AI Risk
                Management Framework. A voluntary framework to better manage
                risks to individuals, organizations, and society. Structured
                around four functions: Govern, Map, Measure, and Manage.
              </p>
              <div className="flex items-center text-sm text-slate-500" data-id="element-547">
                <Info className="h-4 w-4 mr-2" data-id="element-548" />
                <span data-id="element-549">US Dept of Commerce • Version 1.0</span>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}